import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, ArrowRight } from 'lucide-react';
import { Product } from '../types';
import { useLanguage } from '../context/LanguageContext';

export const ProductCard: React.FC<{ product: Product; compact?: boolean }> = ({ product, compact = false }) => {
  const { t } = useLanguage();
  const translatedTitle = t('portfolio', `projects.${product.id}.title`);
  const displayTitle = translatedTitle === `projects.${product.id}.title` ? product.title : translatedTitle;

  const translatedDesc = t('portfolio', `projects.${product.id}.description`);
  const displayDesc = translatedDesc === `projects.${product.id}.description` ? product.description : translatedDesc;

  return (
    <div className="group bg-card rounded-lg border border-border overflow-hidden hover:border-foreground/20 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
      <div className={`${compact ? 'aspect-[16/10]' : 'aspect-video'} w-full overflow-hidden`}>
        <img
          src={product.image}
          alt={displayTitle}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={compact ? 'p-3' : 'p-5'}>
        <h3 className={`${compact ? 'text-sm' : 'text-base'} font-medium mb-1.5 group-hover:text-foreground transition-colors`}>
          {displayTitle}
        </h3>
        <p className={`text-muted-foreground ${compact ? 'text-xs mb-2' : 'text-sm mb-4'} line-clamp-2 leading-relaxed`}>
          {displayDesc}
        </p>

        {product.url.startsWith('/') ? (
          <Link
            to={product.url}
            className={`inline-flex items-center ${compact ? 'text-xs' : 'text-sm'} font-medium hover:underline underline-offset-4`}
          >
            {t('portfolio', 'viewProject')} 
            <ArrowRight className={`ml-1 ${compact ? 'w-2.5 h-2.5' : 'w-3 h-3'}`} />
          </Link>
        ) : (
          <a
            href={product.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center ${compact ? 'text-xs' : 'text-sm'} font-medium hover:underline underline-offset-4`}
          >
            {t('portfolio', 'viewProject')} 
            <ExternalLink className={`ml-1 ${compact ? 'w-2.5 h-2.5' : 'w-3 h-3'}`} />
          </a>
        )}
      </div>
    </div>
  );
};
